import { render, staticRenderFns } from "./TextAreaModal.vue?vue&type=template&id=484d1fb2&scoped=true"
import script from "./TextAreaModal.vue?vue&type=script&lang=ts"
export * from "./TextAreaModal.vue?vue&type=script&lang=ts"
import style0 from "./TextAreaModal.vue?vue&type=style&index=0&id=484d1fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d1fb2",
  null
  
)

export default component.exports